import { useEffect, useState } from "react"
import { updateAPI } from "../api/api"
import { MatchOptions } from "../components/matchOptions"
import { MultipleOptions } from "../components/multipleOptions"
import { TrueFalseOptions } from "../components/trueFalseOptions"

import { OrderAnswers } from "../molecule/orderAnswers"

import { OrderOptions } from "../molecule/OrderOptions"
import { QuizSelectForm, QuizTimeUnit, QuizWeight } from "../atoms/input"
import { HorizontalLayout } from "../components/layout"
import { PhotoOptions } from "../components/photoOptions"
import { OpenQuiz } from "../molecule/OpenQuiz"
import ImageAssessmentComp from "../components/imageAssessmentComp"
import { use } from "react"

export const CreateQuizFactory = ({ type, data, lessonID, moduleID, completeData, updatedContent }) => {
   const [time, setTime] = useState(completeData?.time || 0)
   const [weight, setWeight] = useState(completeData?.weight || 1)
   const [quizType, setQuizType] = useState(completeData?.module_content?.quiz_type || 1)

   const buildBody = (content, type_content, type_id) => {
      const indexed = completeData.indexed_order
      const contentCopy = {}
      contentCopy[type_content] = {
         quiz_question: content?.quiz_question,
         quiz_type: type_id,
         quiz_answers: content.quiz_answer_content,
         quiz_correct_answers: [1,3,5,6].includes(content.quiz_type)
            ? content.quiz_answer_content.filter(r => r.quiz_correct_answer)
            : content.quiz_answers
      }
      return {
         time,
         weight,
         module_content: contentCopy,
         id_lessons: lessonID,
         id_modules: moduleID,
         module_type: 1,
         quiz_type: type_id,
         indexed_order: indexed
      }
   }

   const handleUpdate = (newContent, type_content, type_id) => {
      const body = buildBody(newContent, type_content, type_id)
      console.log("builded focking body",body)
      updatedContent(body) 
   }

   const handleTimeUnitChange = (timed) => {
      setTime(timed)
      const indexed = completeData.indexed_order
      const body = {
         time: timed,
         weight,
         module_content: completeData.module_content,
         id_lessons: lessonID,
         id_modules: moduleID,
         module_type: 1,
         quiz_type: quizType,
         indexed_order: indexed
      }
      updatedContent(body)
   }

   const handleQuizWeightChange = (weighted) => {
      setWeight(weighted)
      const indexed = completeData.indexed_order
      const body = {
         time,
         weight: weighted,
         module_content: completeData.module_content,
         id_lessons: lessonID,
         id_modules: moduleID,
         module_type: 1,
         quiz_type: quizType,
         indexed_order: indexed
      }
      updatedContent(body)
   }

   const handleQuizChange = (type) => {
      const typeCopy = parseInt(type)
      setQuizType(typeCopy)
      const indexed = completeData.indexed_order
      const body = {
         time: time,
         weight: weight,
         module_content: { quiz_content: { quiz_type: typeCopy } },
         id_lessons: lessonID,
         id_modules: moduleID,
         module_type: 1,
         quiz_type: typeCopy,
         indexed_order: indexed
      }
      updatedContent(body)
   }

   return (
      <>
         <HorizontalLayout className="phone-input-comp" style={{ gap: '1rem' }}>
            <QuizSelectForm
               selectedValue={quizType}
               setQuizType={handleQuizChange}
               title={"Selecteer type"}
            />
            <QuizTimeUnit
               value={time}
               setTime={handleTimeUnitChange}
               title="Kies tijdseenheid"
            />
            <QuizWeight
               value={weight}
               setWeight={handleQuizWeightChange}
               title={"Kies gewicht"}
            />
         </HorizontalLayout>
         <QuizChoice
            updateContent={(answers, content, typed) => handleUpdate(answers, content, typed)}
            data={data}
            type={quizType}
         />
      </>
   )
}


const QuizChoice = ({ type, data, updateContent }) => {
useEffect(() => {
      console.log("QuizChoice data:", data);
   }, [data]);

   switch (type || data?.quiz_type || data?.quiz_content?.quiz_type ) {
      case 1: return <MultipleOptions updateAnswer={(answers) => updateContent(answers, "quiz_content", 1)} data={data} />
      case 2: return <MatchOptions  data={data} updateContent={(answers) => updateContent(answers, "quiz_content", 2)}/>
      case 3: return <TrueFalseOptions data={data} updateContent={(answers) => updateContent(answers, "quiz_content", 3)}/>
      case 4: return <OrderOptions data={data} updateContent={(answers) => updateContent(answers, "quiz_content", 4)} />
      case 5: return <PhotoOptions data={data} updateAnswer={(answers) => updateContent(answers, "quiz_content", 5)} />
      case 6: return <OpenQuiz data={data} updateAnswer={(answers) => updateContent(answers, "quiz_content", 6)} />
      default: return <MultipleOptions updateAnswer={(answers) => updateContent(answers, "quiz_content", 1)} data={data} />

   }
}